import { TrackEvent } from "./Tracking";

/**
 * Feature Flag organization
 *
 * Feature Flags within Hopi should be handled via keyboard shortcuts & local or session storage
 * Any flags used for enabling or disabling features should be set here
 *
 * We should have a `set()` function and a `get()` function for each flag
 * Each flag should have a key combination present
 * 		We send the key combination to MouseTrap via Keyboard.setKey()
 * Each flag should be called `flag_` and added to the array at the bottom of this file to ensure all flags are removed on startup
 */


/**
 * HOPI-1303
 * Keyboard Shortcut feature flag for Downloading AdStudio Creatives
 * To enable downloading of AdStudio Creatives we set a property on `localStorage`
 */
export const DOWNLOAD_AS_KEY = "alt+a+s";
export const PARTNER_TAGS_KEY = "alt+p+t";
export const VERSION_PREVIEW_KEY = "alt+v+v";
export const PRVW_1_KEY = "alt+1+1";
export const PRVW_2_KEY = "alt+2+2";
export const VERSION_GEN_SELECTED_PREVIEW_KEY = "t 8 0 0";
export const EXIT_AI_DEV_MODE_KEY = "t 1 0 0 0";
export const ZENDESK_HELP_KEY = "alt+h";

const AS_DOWNLOAD_FLAG = "flag_download-adstudio";
const PARTNER_TAGS_FLAG = "flag_enable_partner_tags";
const VERSION_PREVIEW_FLAG = "flag_enable_version_edit_2";
const PRVW_2_FLAG = "flag_prvw_2";
const AI_DEV_MODE_FLAG = "flag_ai_dev_mode";


export function setDownloadAS(){
	try{
		localStorage.setItem(AS_DOWNLOAD_FLAG, true);
		TrackEvent({
			eventAction: "keyboard-shortcut",
			eventCategory: "Feature Flag",
			eventLabel: "Download AS Creatives",
			value: 1,
		});
	} catch (err){
		console.info("Unable to set Flag, defaulting");
		console.error(err);
	}
}

export function getDownloadAS(){
	let canDownload = false;

	try {
		canDownload = localStorage.getItem(AS_DOWNLOAD_FLAG);
	} catch (err){
		console.info("Unable to get Flag, defaulting to %cfalse%c", "color: #44287c; font-weight:bold;", "color:#000;font-weight:normal;");
		console.error(err);
	}

	return Boolean(canDownload);
}

/**
 * HOPI-1676
 * Keyboard Shortcut feature flag for Partner Creatives
 * To enable creation of Partner Creatives when making new Open Web Concept
 */
export function setPartnerTags(){
	try{
		localStorage.setItem(PARTNER_TAGS_FLAG, true);
		TrackEvent({
			eventAction: "keyboard-shortcut",
			eventCategory: "Feature Flag",
			eventLabel: "Partner Tags",
			value: 1,
		});
	} catch (err){
		console.info("Unable to set Flag, defaulting");
		console.error(err);
	}
}

export function getPartnerTags(){
	let dancePartner = false;

	try {
		dancePartner = localStorage.getItem(PARTNER_TAGS_FLAG);
	} catch (err){
		console.info("Unable to get Flag, defaulting to %cfalse%c", "color: #44287c; font-weight:bold;", "color:#000;font-weight:normal;");
		console.error(err);
	}

	return Boolean(dancePartner);
}

/**
 * clearItem()
 * 		Clears the given item from localStorage
 * @param  {string} flagName The localStroage item we want to remove
 * @return {void}
 */
export function clearItem(flagName){
	try {
		localStorage.removeItem(flagName);
	} catch (err){
		console.info(`Unable to remove flag - %c${flagName}%c`, "color:#dd9ed8; font-weight:bold", "color:#000;font-weight:normal;");
	}
}

export function clearFlags(flags = []){
	flags.forEach(clearItem);
}

export function enablePreviewVersion2(){
	try {
		localStorage.setItem(VERSION_PREVIEW_FLAG, true);
	} catch (err){
		console.info("Unable to set Flag");
		console.error(err);
	}
}

export function getPreviewVersion2(){
	let versionType = false;

	try {
		versionType = localStorage.getItem(VERSION_PREVIEW_FLAG);
	} catch (err){
		console.info("Unable to get Flag, defaulting to %cfalse%c", "color: #44287c; font-weight:bold;", "color:#000;font-weight:normal;");
		console.error(err);
	}

	return Boolean(versionType);
}

export function enablePRVW(){
	try {
		localStorage.setItem(PRVW_2_FLAG, true);
	} catch (err){
		console.info("Unable to set Flag");
		console.error(err);
	}
}

export function disablePRVW(){
	try {
		localStorage.removeItem(PRVW_2_FLAG);
	} catch (err){
		console.info("Unable to Clear Flag");
		console.error(err);
	}
}

export function enableAIDevMode(){
	try {
		localStorage.setItem(AI_DEV_MODE_FLAG, true);

		console.info("%cAI%c Dev Mode %cEnabled!%c \n\nEnjoy the ride\n\n🕶️🕶️🕶️🕶️🕶️🕶️🕶️🕶️🕶️🕶️",
			"color: #cd0184; font-weight:bold;",
			"color:#000;font-weight:normal; text-decporation:underline;",
			"color:#19b540; font-weight:bold;",
			"color:#000;font-weight:normal;"
		);
	} catch (err){
		console.info("Unable to set Flag");
		console.error(err);
	}
}

export function disableAIDevMode(){
	try {
		localStorage.removeItem(AI_DEV_MODE_FLAG);

		console.info("%cAI%c Dev Mode %Terminated!%c",
			"color: #cd0184; font-weight:bold;",
			"color:#000;font-weight:normal; text-decporation:underline;",
			"color:#000;font-weight:normal;"
		);
	} catch (err){
		console.info("Unable to clear Flag");
		console.error(err);
	}
}

export function getVersionGenSelectedPreview(){
	let showPreview = false;
	try{
		showPreview = localStorage.getItem(AI_DEV_MODE_FLAG);
	} catch(e){
		console.info("Unable to get Flag");
		console.error(e);
	}

	return Boolean(showPreview);
}

export function toggleZendeskHelp(){
	const launcher = document.querySelector("iframe#launcher");
	if(!launcher){ return; }

	const display = launcher?.style?.display;

	if(display === "none"){
		launcher.style.display = "block";
	} else {
		launcher.style.display = "none";
	}
}

// These are the features that we want to reset on load of the app
export const FLAG_POLE = [
	AS_DOWNLOAD_FLAG,
	PARTNER_TAGS_FLAG,
	// VERSION_PREVIEW_KEY,
	// AI_VERSIONS_KEY,
	// PRVW_2_FLAG
];
